import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import "./EventCompliance.css";

export function EventCompliance({ percent, missedCount, studyLocked }) {
  const { t } = useTranslation();

  if (studyLocked) {
    return <div className="home__status"><small className="event-compliance">{t("home.study_locked")}</small></div>;
  }

  // New participant: no events have closed their availability window yet,
  // so the backend returns percent=0 / missedCount=0. Showing "0% Compliance"
  // here is misleading — they have not missed anything; there is just nothing
  // to score yet. Hide the widget until there is something meaningful to report.
  if (percent === 0 && missedCount === 0) {
    return null;
  }

  const key =
    missedCount === 1
      ? "home.event_compliance.summary_with_missed_one"
      : "home.event_compliance.summary_with_missed_other";

  return (
    <div className="home__status"><small className="event-compliance">
      {t(key, { percent, count: missedCount })}
    </small>
    </div>
  );
}

EventCompliance.propTypes = {
  percent: PropTypes.number.isRequired,
  missedCount: PropTypes.number.isRequired,
  studyLocked: PropTypes.bool.isRequired,
};
